import React from "react";
import { Link } from "react-router-dom";

export default function WhatsAppHeader({ toggleSidebar }) {
  return (
    <div className="mainHead d-flex align-items-center justify-content-between pt-3 py-3">
      <div className="headTitle ms-3 text-white">
        <h1 className="fs-4 fw-bold mb-1">WhatsApp Reports</h1>
        <span className="fs-6">
          Track delivery status of lab &amp; ginni reports sent to customers
        </span>
      </div>

      <div className="headIcons d-flex me-3">
        {/* <div className="iconMain">
          <i className="fa-solid fa-search"></i>
        </div>

        <div className="iconMain ms-3">
          <i className="bi bi-bell-fill"></i>
        </div>

        <Link to="/dashboard" className="iconMain ms-3 me-3">
          <i className="fa-solid fa-exclamation" style={{ color: "black" }}></i>
        </Link> */}

        <div className="iconMain" onClick={toggleSidebar}>
          <i className="fa-solid fa-bars"></i>
        </div>
      </div>
    </div>
  );
}
